import { Box, Text, useTranslation } from "@familyzone/component-library";
import React from "react";

export interface StatusChipProps {
  action: number;
  size?: string;
  marginRight?: string;
  lineHeight?: string;
}

export const ACTION_BLOCKED = 0;
export const ACTION_ALLOWED = 1;

export const ALLOWED_TEXT = "Allowed";
export const BLOCKED_TEXT = "Blocked";

const StatusChip: React.FC<StatusChipProps> = ({ action, size = "x-small", lineHeight = "16px", marginRight }) => {
  const { t } = useTranslation();

  const text = action === ACTION_ALLOWED ? t(ALLOWED_TEXT) : t(BLOCKED_TEXT);
  const color = action === ACTION_ALLOWED ? "accent.green.100" : "accent.orange.200";
  const textColor = action === ACTION_ALLOWED ? "neutrals.900" : "neutrals.900";
  const mr = marginRight ? marginRight : action === ACTION_ALLOWED ? undefined : "sp4";

  return (
    <Box bgColor={color} p="2px 8px" borderRadius="200px" mr={mr}>
      <Text color={textColor} fontSize={size} fontWeight="medium" letterSpacing="0.01em" lineHeight={lineHeight}>
        {text}
      </Text>
    </Box>
  );
};

export default StatusChip;
